const HEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export function emptyHoneycombColorMaps() {
  return { accent: {}, ring: {}, surface: {}, stroke: {} };
}

function parseFillLineScale(raw) {
  if (typeof raw !== 'number' || !Number.isFinite(raw)) return undefined;
  const stepped = Math.round(raw / 0.05) * 0.05;
  return Math.min(2, Math.max(0.05, Math.round(stepped * 100) / 100));
}

function parseHexMap(raw) {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const out = {};
  for (const [key, value] of Object.entries(raw)) {
    if (typeof value === 'string' && HEX.test(value)) {
      out[key] =
        value.length === 4
          ? `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`.toLowerCase()
          : value.toLowerCase();
    }
  }
  return out;
}

export function parseHoneycombColorMaps(raw) {
  if (!raw || typeof raw !== 'object') return emptyHoneycombColorMaps();
  const pattern = raw.pattern === 'outline' || raw.pattern === 'fill' ? raw.pattern : undefined;
  const fillLineScale = parseFillLineScale(raw.fillLineScale);
  return {
    accent: parseHexMap(raw.accent),
    ring: parseHexMap(raw.ring),
    surface: parseHexMap(raw.surface),
    stroke: parseHexMap(raw.stroke),
    ...(pattern ? { pattern } : {}),
    ...(fillLineScale != null ? { fillLineScale } : {}),
  };
}
